/**
 * slack_list_dms — canonical manifest (zero imports, shared with tool-runtime).
 *
 * Lists recent direct message conversations in the user's Slack workspace.
 * Used by the contacts-slack-scan skill to discover people to create contacts for.
 */

export const MANIFEST = {
  name: 'slack_list_dms',
  description: `List recent Slack DM conversations.

**INTEGRATION REQUIRED:** User must connect a Slack workspace in Settings → Integrations first.

**USE CASES:**
- Discover which people the user has messaged on Slack (for contact sync)
- Get a quick overview of recent DM activity

**EXAMPLES:**

List last 20 DMs (default):
{}

List from a specific workspace:
{ "workspaceId": "T012AB3CD" }

List more conversations:
{ "limit": 50 }

**RETURNS:**
Array of { channelId, userId, userName, userEmail, lastMessage, lastMessageTs, workspaceId }`,
  inputSchema: {
    type: 'object' as const,
    properties: {
      workspaceId: {
        type: 'string',
        description: 'Slack team ID (T...) to list DMs from. Omit to use any connected workspace.',
      },
      limit: {
        type: 'number',
        description: 'Number of conversations to return (1–100, default 20)',
      },
    },
    required: [],
  },
} as const;
